import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { ShopboxCommonModule } from '@shared/common/common.module';

import { MainComponent, OverviewToolbarComponent, CommandMenuComponent } from './components';
import { OverviewTabComponent, CategorySalesTabComponent, ItemsSalesTabComponent } from './pages';

@NgModule({
    imports: [
    ShopboxCommonModule,
    RouterModule,
    MainComponent,
    OverviewTabComponent,
    CategorySalesTabComponent,
    ItemsSalesTabComponent,
    OverviewToolbarComponent,
    CommandMenuComponent
]
})
export class DashboardModule { }
